import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { isAuthenticated, getIdToken } from "../lib/tokenStorage";
import { setCredentials, selectCurrentToken } from "../authSlice";
import { isTokenExpired, refreshCognitoTokens } from "../lib/refreshTokens";
import { decodeClaims } from "../lib/decodeClaims";

const useRestoreAuthSessionOnce = () => {
  const dispatch = useDispatch();
  const tokenInRedux = useSelector(selectCurrentToken);
  const [status, setStatus] = useState(
    tokenInRedux ? "authenticated" : "unknown"
  );

  useEffect(() => {
    if (status !== "unknown") return;

    setStatus("restoring");

    const run = async () => {
      try {
        if (!isAuthenticated()) {
          setStatus("unauthenticated");
          return;
        }
        let idToken = getIdToken();
        if (idToken && isTokenExpired(idToken)) {
          const refreshed = await refreshCognitoTokens();
          if (!refreshed) {
            setStatus("unauthenticated");
            return;
          }
          idToken = getIdToken();
        }
        if (!idToken) {
          setStatus("unauthenticated");
          return;
        }
        const { uid, roles } = decodeClaims(idToken);
        dispatch(setCredentials({ token: idToken, uid, roles }));
        setStatus("authenticated");
      } catch {
        setStatus("unauthenticated");
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { status };
};

export default useRestoreAuthSessionOnce;
